import styled from 'styled-components';

import { NotificationContainer } from '../NotificationContainer';

const StyledNotificationContainer = styled(NotificationContainer)`
	&.info {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	&.success {
		background-color: #1f8034;
	}

	&.error {
		background-color: #c71e1e;
	}
`;

export { StyledNotificationContainer };
